// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plan-sliders[data-v-64fec190]{padding-left:.5rem;padding-right:.5rem}@media(min-width:1244px){.plan-sliders[data-v-64fec190]{padding-left:0;padding-right:0}}.plans[data-v-64fec190]{display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));margin:1.5rem 0;text-align:left}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
